/**
 * Extras permissions filter used for deciding to show extras based on:
 * multi rates support
 * options support
 * validity support
 */
bookingApp.filter('extraPermissions',['$filter',function(){
    var extrasPermissionFilter = function(input, multiRatesSupported, optionsSupported, validitySupported){
        var out = [];
        angular.forEach(input, function(extra){
            var addExtra = true;
            if(Object.keys(extra.rates).length > 1 && !multiRatesSupported){
                addExtra = false;
            }
            if(extra.options.length > 0 && !optionsSupported){
                addExtra = false;
            }
            if(extra.validityPeriod !== null && !validitySupported){
                addExtra = false;
            }
            if(addExtra){
                out.push(extra);
            }
        });
        return out;
    };
    return extrasPermissionFilter;
}]);